<section class="cv-list" [nbSpinner]="isLoading" nbSpinnerStatus="primary">
  <bst-dual-axis #dualAxisComponent
                 [tag]="'cv'"
                 [delegate]="this"
                 [bootstrap]="true">
  </bst-dual-axis>
</section>

<ng-template #cellTemplate let-item="row" let-column="column">
  @switch (column.name) {
    @case ('created_at') {
      <span [nbTooltip]="item.created_at | date:'long'">
        {{ item.created_at | date:'longDate' }}
      </span>
    }
    @case ('template_id') {
      <span>{{ templateLabel(item) }}</span>
    }
    @case ('subject_user_name') {
      @if (item.subject_user_name) {
        <span>{{ item.subject_user_name }}</span>
      } @else {
        <span class="muted">#{{ item.subject_user_id }}</span>
      }
    }
    @case ('client_name') {
      @if (item.client_name) {
        <span>{{ item.client_name }}</span>
      } @else {
        <span class="muted">#{{ item.client_id }}</span>
      }
    }
    @case ('locale') {
      <span>{{ localeLabel(item) }}</span>
    }
    @case ('pdf_size_bytes') {
      <span class="tabular">{{ formatSize(item.pdf_size_bytes) }}</span>
    }
    @case ('expires_at') {
      @if (item.expires_at) {
        <span class="expires-cell" [class.expires-soon]="isExpiringSoon(item)">
          @if (isExpiringSoon(item)) {
            <nb-icon icon="alert-triangle-outline" status="warning"
                     [nbTooltip]="expiryTooltip(item)"></nb-icon>
          }
          <span>{{ item.expires_at | date:'longDate' }}</span>
        </span>
      } @else {
        <span class="muted">{{ 'cv.list.neverExpires' | translate }}</span>
      }
    }
    @case ('actions') {
      <div class="row-actions">
        <button nbButton ghost status="primary" size="small"
                (click)="onPreview(item)"
                [attr.aria-label]="'cv.list.preview' | translate"
                [nbTooltip]="'cv.list.preview' | translate">
          <nb-icon icon="eye-outline"></nb-icon>
        </button>
        <button nbButton ghost status="primary" size="small"
                (click)="onDownload(item)"
                [attr.aria-label]="'cv.list.download' | translate"
                [nbTooltip]="'cv.list.download' | translate">
          <nb-icon icon="download-outline"></nb-icon>
        </button>
        <button nbButton ghost status="danger" size="small"
                (click)="onDelete(item)"
                [disabled]="isDeleting(item)"
                [attr.aria-label]="'cv.list.delete' | translate"
                [nbTooltip]="'cv.list.delete' | translate">
          <nb-icon icon="trash-2-outline"></nb-icon>
        </button>
      </div>
    }
    @default {
      <span class="muted">{{ item[column.name] ?? '-' }}</span>
    }
  }
</ng-template>
